var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tree-item-crud" }, [
    _c("div", { staticClass: "tree-item-content" }, [
      _vm.item.children && _vm.item.children.length
        ? _c(
            "span",
            {
              staticClass: "toggle",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleExpand.apply(null, arguments)
                },
              },
            },
            [
              _c("b-icon", {
                attrs: {
                  icon: _vm.isExpanded ? "minus" : "plus",
                  size: "is-small",
                },
              }),
            ],
            1
          )
        : _c("span", { staticClass: "toggle-spacer" }),
      _c("div", { staticClass: "tree-item-name-section" }, [
        _vm.isEditing
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editName,
                  expression: "editName",
                },
              ],
              ref: "editInput",
              staticClass: "tree-edit-input",
              attrs: { type: "text" },
              domProps: { value: _vm.editName },
              on: {
                keyup: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.saveEdit.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    )
                      return null
                    return _vm.cancelEdit.apply(null, arguments)
                  },
                ],
                click: function ($event) {
                  $event.stopPropagation()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.editName = $event.target.value
                },
              },
            })
          : _c("span", { staticClass: "tree-item-name" }, [
              _vm._v(_vm._s(_vm.item.name)),
            ]),
      ]),
      _c(
        "div",
        { staticClass: "tree-item-actions" },
        [
          !_vm.isEditing
            ? [
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: "ערוך",
                      type: "is-dark",
                      "append-to-body": true,
                      position: "is-top",
                    },
                  },
                  [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        "icon-left": "pencil",
                        type: "is-info",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.startEdit.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: "הוסף קטגוריה בת",
                      type: "is-dark",
                      "append-to-body": true,
                      position: "is-top",
                    },
                  },
                  [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        "icon-left": "plus",
                        type: "is-success",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.startAddChild.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: "העבר קטגוריה",
                      type: "is-dark",
                      "append-to-body": true,
                      position: "is-top",
                    },
                  },
                  [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        "icon-left": "arrow-left-right",
                        type: "is-warning",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.moveCategory.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: _vm.deleteTooltip,
                      type: "is-dark",
                      "append-to-body": true,
                      position: "is-top",
                    },
                  },
                  [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        "icon-left": "delete",
                        type: "is-danger",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.deleteCategory.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: "שמור",
                      type: "is-dark",
                      "append-to-body": true,
                      position: "is-top",
                    },
                  },
                  [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        "icon-left": "check",
                        type: "is-success",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.saveEdit.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: "ביטול",
                      type: "is-dark",
                      "append-to-body": true,
                      position: "is-top",
                    },
                  },
                  [
                    _c("b-button", {
                      attrs: {
                        size: "is-small",
                        "icon-left": "close",
                        type: "is-danger",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.cancelEdit.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ]),
    _vm.isAddingChild
      ? _c("div", { staticClass: "tree-add-child" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newChildName,
                expression: "newChildName",
              },
            ],
            ref: "addChildInput",
            staticClass: "tree-add-input",
            attrs: { type: "text", placeholder: "שם קטגוריה חדשה..." },
            domProps: { value: _vm.newChildName },
            on: {
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.saveChild.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  return _vm.cancelAddChild.apply(null, arguments)
                },
              ],
              click: function ($event) {
                $event.stopPropagation()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.newChildName = $event.target.value
              },
            },
          }),
          _c(
            "div",
            { staticClass: "tree-add-actions" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    size: "is-small",
                    "icon-left": "check",
                    type: "is-success",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.saveChild.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" שמור ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    size: "is-small",
                    "icon-left": "close",
                    type: "is-danger",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.cancelAddChild.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" ביטול ")]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm.isExpanded && _vm.item.children && _vm.item.children.length
      ? _c(
          "div",
          { staticClass: "tree-children" },
          _vm._l(_vm.item.children, function (child) {
            return _c("TreeItemCRUD", {
              key: child.id,
              attrs: { item: child },
              on: {
                edit: function ($event) {
                  return _vm.$emit("edit", $event)
                },
                "add-child": function ($event) {
                  return _vm.$emit("add-child", $event)
                },
                move: function ($event) {
                  return _vm.$emit("move", $event)
                },
                delete: function ($event) {
                  return _vm.$emit("delete", $event)
                },
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }